import React from 'react';
import {Input} from '@components/form/Input';

export const Select = (props) => {
    let {options = [], value, displayEmpty, visibleEmptyOption = false, ...other} = props;
    let currentValue = value || "DEFAULT";
    return (
        <Input
            select
            SelectProps={{
                native: true,
                label: props.label,
                displayEmpty,
                value: currentValue
            }}
            {...other}
        >

            <option value={'DEFAULT'} disabled style={{display: visibleEmptyOption ? 'initial' : 'none'}}></option>

            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </Input>
    )
};
